import { request, request2 } from './index.js'

// 老师、管理员登录
export const login = data => request(`api/authV2/admin_login`, 'post', {
    data
})
// 学校登录
export const yey_login = data => request(`api/authV2/yey_login`, 'post', {
    data
})


// 学期
export const getTerm = () => request(`api/config/term`, 'post')
// 标签
export const getTags = () => request(`api/config/tags`, 'post')
// 课程选项
export const options = (data) => request(`api/admin/course/options`, 'post', {
    data
})

// 上传文件
export const upload = (data) => request(`api/admin/file/upload`, 'post', {
    data
})
// 大上传文件
export const oss_sts = (data) => request(`api/admin/file/oss_sts`, 'post', {
    data
})

// 保存资源
export const saveResource = (data) => request(`api/admin/resource/save`, 'post', {
    data
})

// 获取课程
export const getCourse = (term) => request(`api/admin/course/options`, 'post', {
    data: { term }
})

// 资源列表
export const getResource = (data) => request(`api/admin/resource/find`, 'post', {
    data
})
// 资源列表
export const findResource = (data) => request(`api/admin/resource/find`, 'post', {
    data
})

// 资源审核
export const verify = (data) => request(`api/admin/resource/verify`, 'post', {
    data
})

// 删除审核
export const deleteResource = (data) => request(`api/admin/resource/delete`, 'post', {
    data
})

// 资源目录列表
export const group = (data) => request(`api/admin/resource/group`, 'post', {
    data
})

// 下载全部
export const downloadAll = (id) => request(`api/admin/resource/download_v2?id=${id}`, 'get', {
    responseType: "blob"
})

// 下载指定文件
export const downloadFile = (ids) => request(`api/admin/resource_file/download_by_ids`, 'post', {
    data: { ids },
    responseType: "blob"
})

// 用户列表
export const userFind = (data) => request(`api/admin/user/find`, 'post', {
    data
})
// 学校列表
export const schoolList = (data) => request(`api/admin/user/school_list`, 'post', {
    data
})
// 省
export const province = (data) => request(`api/area/province`, 'post', {
    data
})
// 市
export const city = (data) => request(`api/area/city`, 'post', {
    data
})
// 区
export const area = (data) => request(`api/area/area`, 'post', {
    data
})
// 幼儿园(学校注册用)
export const yey = (data) => request(`api/area/yey`, 'post', {
    data
})
// 幼儿园(老师注册用)
export const school = (data) => request(`api/area/school`, 'post', {
    data
})
// 保存用户
// https://yey.mashu.cloud/api/admin/user/save
export const userSave = (data) => request(`api/admin/user/save`, 'post', {
    data
})
// 修改学校信息
export const editSchool = (data) => request(`api/admin/user/edit_school`, 'post', {
    data
})
// 修改学校状态
export const schoolAccountStatus = (data) => request(`api/admin/user/account_status`, 'post', {
    data
})
// 删除
export const schoolUseDelete = (data) => request(`api/admin/user/delete`, 'post', {
    data
})
// 上下架
export const resourceShelf = (data) => request(`api/admin/resource/shelf`, 'post', {
    data
})

//非全部下载保存下载记录
export const saveDownloadRecord = (files_id) => request(`api/admin/resource/single_download_v2`, 'post', {
    data: { files_id }
})

// 收藏、取消收藏
export const collect = (id) => request(`api/admin/resource/collect`, 'post', {
    data: { id }
})

// 我的收藏
export const collect_list = (page) => request(`api/admin/resource/collect_list`, 'post', {
    data: { page }
})

// 我的下载
export const download_list = (page) => request(`api/admin/resource/download_list_v2`, 'post', {
    data: { page }
})

// 关注/取消关注用户
export const follow = (user_id) => request(`api/admin/user/follow`, 'post', {
    data: { user_id }
})
// 我的关注
export const my_follow = (page) => request(`api/admin/user/my_follow`, 'post', {
    data: { page }
})
// 资源详情
export const resDetail = (id) => request(`api/admin/resource/detail`, 'post', {
    data: { id }
})
// 查用户信息
export const getUserInfo = (id) => request(`api/admin/user/info_by_id`, 'post', {
    data: { id }
})
// 删除下载记录
export const delDownloadRecord = (id) => request(`api/admin/resource/delete_download_log_v2`, 'post', {
    data: { id }
})
// 批量删除下载记录
export const delDownloadRecordBatch = (ids) => request(`api/admin/resource/delete_download_v2_by_ids`, 'post', {
    data: { ids }
})
// 根据用户ID获取资源列表
export const getUserResource = (id, page) => request(`api/admin/resource/find_by_user`, 'post', {
    data: { id, page }
})
// 我的粉丝
export const getFans = (page) => request(`api/admin/user/follow_me`, 'post', {
    data: { page }
})

// 发送验证码
export const send_sms = (data) => request(`api/auth/send_sms`, 'post', {
    data
})
// 验证码登录
export const sms_auth = (data) => request(`api/auth/sms_auth`, 'post', {
    data
})
// 验证码注册验证
export const check_register_sms = (data) => request(`api/auth/check_register_sms`, 'post', {
    data
})
// 用户注册
export const register = (data) => request(`api/authV2/register`, 'post', {
    data
})
// 上传营业执照
export const authUpload = (data) => request(`api/auth/upload`, 'post', {
    data
})

// 用户审核
export const adminVerify = (data) => request(`api/admin/user/verify`, 'post', {
    data
})

// 发送验证码(修改信息用)
export const send_sms2 = (data) => request(`api/admin/user/send_sms`, 'post', {
    data
})
// 修改手机
export const update_phone = (data) => request(`api/admin/user/update_phone`, 'post', {
    data
})
// 修改个人信息
export const update_self = (data) => request(`api/admin/user/update_self`, 'post', {
    data
})

// 忘记密码验证
export const check_forget_sms = (data) => request(`api/authV2/check_forget_sms`, 'post', {
    data
})

// 忘记密码V2
export const forget_password = (data) => request(`api/authV2/forget_password_v2`, 'post', {
    data
})

// 学校文件总大小
export const school_file_size = (data) => request(`api/admin/user/school_file_size`, 'post', {
    data
})

// 获取手机号状态
export const check_phone_status = (data) => request(`api/authV2/check_phone_status `, 'post', {
    data
})
// 根据手机号查用户信息
export const find_info_by_phone = (data) => request(`api/authV2/find_info_by_phone `, 'post', {
    data
})

// 超管创建学校
export const add_school_account = (data) => request(`api/admin/user/add_school_accountV2`, 'post', {
    data
})
// 查询用户是否已注册
export const check_phone_exists = (data) => request(`api/auth/check_phone_exists`, 'post', {
    data
})
// 新增用户角色
export const add_ext_role = (data) => request(`api/admin/user/add_ext_role`, 'post', {
    data
})


// 学校导出 
export const exportSchool = () => request2(`api/school/export`)

// 批量添加幼儿园账号
export const importAccount = (data) => request(`api/admin/user/import_school_user`, 'post', {
    data
})
// 获取短信状态
export const getSmsState = (data) => request(`api/school/sms_report`, 'post', {
    data
})
